import { isEmpty } from "lodash";
import React, { useContext, useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addInviteRecord, getAllUsers, getUsers } from "../firebase/controller/invites";
import { sendEmail } from "../firebase/controller/mailer";

const InviteContext = React.createContext();

export function useInvite() {
  return useContext(InviteContext);
}

export function InviteProvider({ children }) {
  const { user } = useSelector((state) => state.authStore);
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [users, setUser] = useState([]);
  const [offset, setOffset] = useState(null);
  const [count, setCount] = useState(0);
  const [done, setDone] = useState(false);

  const listUsers = useCallback(async () => {
    try {
      setLoader(true);
      const res = await getUsers(offset, setOffset);
      const total = await getAllUsers();
      setCount(count + total.length);
      setUser([...users, ...res]);
      setLoader(false);
    } catch (error) {
      const message = error.message;
      toast.error(message);
      setLoader(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const listNextUsers = async () => {
    try {
      if (!isEmpty(user)) {
        setLoading(true);
        const res = await getUsers(offset, setOffset);
        setUser([...users, ...res]);
        setLoading(false);
      }
    } catch (error) {
      const message = error.message;
      toast.error(message);
      setLoading(false);
    }
  };

  const generateInviteId = (length = 8) => {
    return Math.random().toString(16).substr(2, length);
  };

  const sendInvite = async (data) => {
    try {
      setLoading(true);
      const res = await addInviteRecord({ ...data, id: generateInviteId(26) });
      if(res){
        // to send mail invite
        sendEmail({
          templateID: 'template_1wmojmv', params: {
          invite_from: user.name,
          link: 'https://main--monumental-froyo-28c027.netlify.app/register/?ref='+user.uid
        }
        }).then(function (response) {
          console.log('SUCCESS!', response.status, response.text);
        }, function (error) {
          console.log('FAILED...', error);
        });
        toast.success(`${data.name} will recieve an invitation`);
      }
      setLoading(false);
      setDone(true);
    } catch (err) {
      toast.error("There is an error adding project detail, try again");
      setLoading(false);
      setDone(true);
    }
    
  }

  useEffect(() => {
    !isEmpty(user) && listUsers();
  }, [listUsers, user]);

  const value = {
    loading,
    sendInvite,
    setLoading,
    done, setDone,
    users,
    listNextUsers,
    offset,
    count,
    loader,
  };

  return <InviteContext.Provider value={value}>{children}</InviteContext.Provider>;
}
